import { fetchTree } from "./actions";
import reducer from "./reducer";
import { getPartTree } from "./selectors";
import type { ITreeReducerState } from "./types";
import type { ITreeStructure } from "../../types/tree";

export default reducer;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
export const fetchMachineTree = (machineNumber: string) => fetchTree("core-app/api/original-supply/machine/" + encodeURIComponent(machineNumber));
export const getMachineTree = (state: { partTree: ITreeReducerState }, machineNumber: string): ITreeStructure =>
  getPartTree(state, "core-app/api/original-supply/machine/" + encodeURIComponent(machineNumber));
